import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import overlayFactory from "react-bootstrap-table2-overlay";
import {
  otpSend,
  otpVerify,
  userListResetPassword,
} from "app/services/memberService";
import { Dropdown, DropdownButton } from "react-bootstrap";

import { getUsersList } from "app/services/UserService";
import queryString from "app/services/queryStringService";

import { AiOutlineCopy } from "react-icons/ai";
import { MdEdit, MdRefresh, MdSearch, MdVpnKey } from "react-icons/md";

import Tooltip from "rc-tooltip";
import { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NotificationManager } from "react-notifications";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import { AiFillMail } from "react-icons/ai";
import { FaPhoneAlt, FaUserAlt } from "react-icons/fa";
import { AppContext } from "app/appContext";
import { encryptMessage } from "app/services/CommonService";
import { signOut } from "app/services/AuthService";

const Users = () => {
  const context = useContext(AppContext);
  const navigate = useNavigate();
  const { canAdd, canEdit, canDelete } = usePagePermission();

  const [data, setData] = useState([]); // main table data
  const [tableData, setTableData] = useState([]); // clone table data to filter

  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const [isShowFilter, setIsShowFilter] = useState(false);

  // filter search input

  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [UserName, setUserName] = useState("");
  const [Email, setEmail] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [Address, setAddress] = useState("");
  const [RoleName, setRoleName] = useState("");

  // search function operator

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "FirstName":
        setFirstName(value);
        break;

      case "LastName":
        setLastName(value);

        break;
      case "UserName":
        setUserName(value);

        break;

      case "Email":
        setEmail(value);

        break;

      case "PhoneNumber":
        setPhoneNumber(value);
        break;

      case "Address":
        setAddress(value);
        break;

      case "RoleName":
        setRoleName(value);
        break;

      default:
        break;
    }
  };

  const refreshFilter = (e) => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setUserName("");
    setTableData(data);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const actionHandler = (row) => {
    navigate("/admin/users/edit", { state: row });
  };
  // const actionFormatter = (cell, row) => {
  //   return (
  //     <FaRegEdit
  //       className="text-primary"
  //       onClick={() => actionHandler(row)}
  //       cursor={"pointer"}
  //     />
  //   );
  // };
  const emailFormatter = (cell, row) => {
    // console.log(row);
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{row.email}</div>}
      >
        <span style={{ whiteSpace: "nowrap" }}>
          {row.email.substring(0, 10)}...
          <AiOutlineCopy
            cursor={"pointer"}
            className="ms-1"
            onClick={async () => {
              if ("clipboard" in navigator) {
                await navigator.clipboard.writeText(row.email);
                NotificationManager.success(
                  "Copied successfully ",
                  "Success",
                  5000
                );
              }
            }}
          />
        </span>
      </Tooltip>
    );
  };
  const handleResetPassword = async (row, context) => {
    let passwordData = null;
    debugger;
    const warningMessage =
      row.username === context.user.name
        ? `<span style="font-size: 0.70rem; background-color: #f8d7da; color: #721c24; padding: 6px 10px; border-radius: 4px; display: block; margin-top: 10px;">
You will be signed out automatically after changing your password
      </span>`
        : "";
    // Step 1 & 2: Get password and send OTP in same modal
    const { isConfirmed: proceedToOTP } = await Swal.fire({
      title: `Reset Password`,
      text: "You clicked the button!",
      html: `
      <form autocomplete="off">
        <span>User Name - ${row.username}</span>
        <input type="hidden" id="memberId" value="${row.userId}" />
        <input id="pwd" placeholder="New Password" class="swal2-input" type="password">
        <input id="con-pwd" placeholder="Confirm Password" class="swal2-input" type="password">
      </form>
       ${warningMessage}
      `,
      showCancelButton: true,
      confirmButtonText: "Proceed",
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: async () => {
        const password = document.getElementById("pwd")?.value;
        const confirmPassword = document.getElementById("con-pwd")?.value;
        const strongPasswordRegex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=(?:.*[^A-Za-z0-9]){2,}).{6,10}$/;

        if (password.length > 10) {
          Swal.showValidationMessage(`Maximum 10 digits allowed`);
          return false;
        }
        if (!password || !confirmPassword) {
          Swal.showValidationMessage(
            `Password and Confirm Password are required.`
          );
          return false;
        }
        if (password !== confirmPassword) {
          Swal.showValidationMessage(`Passwords do not match.`);
          return false;
        }
        if (password.length < 6) {
          Swal.showValidationMessage(`Password must be at least 6 characters.`);
          return false;
        }
        if (!strongPasswordRegex.test(password)) {
          Swal.showValidationMessage(
            `Password must be 6-10 characters, include 1 uppercase, 1 lowercase, 1 number, and 2 special characters.`
          );
          return false;
        }

        // Call OTP send API here
        try {
          const req = { userName: context.user.name };
          const response = await otpSend(req);
          if (response.status === "Success") {
            NotificationManager.success(response.message, "Success");
            passwordData = { password, memberId: row.userId };
            return true;
          }
          throw new Error(response.message || "Failed to send OTP");
        } catch (error) {
          Swal.showValidationMessage(error.message || "Something went wrong");
          return false;
        }
      },
    });

    if (!proceedToOTP || !passwordData) return;

    // Step 3: OTP Verification
    const { value: otpVerified } = await Swal.fire({
      title: "Verify OTP",
      html: row?.isOtpEnable
        ? `To your registered mobile number`
        : `To your registered Email`,
      input: "text",
      inputPlaceholder: "Enter the OTP",
      inputAttributes: {
        maxlength: 6,
        minlength: 6,
        autocapitalize: "off",
        autocorrect: "off",
      },
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Verify OTP",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async (otpInput) => {
        if (!/^\d{6}$/.test(otpInput)) {
          Swal.showValidationMessage("OTP must be exactly 6 digits");
          return false;
        }

        try {
          const request = {
            otPkey: encryptMessage(
              `userName=${context.user.name}|otp=${otpInput}`
            ),
          };
          const verifyResponse = await otpVerify(request);
          if (verifyResponse.status === "Success") return true;
          throw new Error(verifyResponse.message || "Invalid OTP");
        } catch (error) {
          Swal.showValidationMessage(error.message || "Verification failed");
          return false;
        }
      },
    });

    if (!otpVerified) return;

    // Step 4: Final Reset Password API Call
    try {
      const res = await userListResetPassword(passwordData);
      if (res.status === "Success") {
        Swal.fire({
          title: "Password Reset Successful",
          text: res.message,
          icon: "success",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed && row.username === context.user.name) {
            signOut(navigate, context);
          }
        });
      } else {
        Swal.fire("Error", res.message || "Reset failed", "error");
      }
    } catch (error) {
      Swal.fire("Error", error.message || "Reset failed", "error");
    }
  };
  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            onClick={() => actionHandler(row)}
            className="btn btn-link"
          >
            <MdEdit className="text-primary me-4" size={15}></MdEdit>
            Edit
          </Dropdown.Item>

          <Dropdown.Item
            onClick={() => handleResetPassword(row, context)}
            href="#"
          >
            <MdVpnKey size={15} className="text-danger me-4"></MdVpnKey> Reset
            Password
          </Dropdown.Item>
        </DropdownButton>
      </>
    );
  };

  const columns = [
    {
      dataField: "userId",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return {
          width: "100px",
          textAlign: "center",
        };
      },
      formatter: actionFormatter,
    },
    {
      dataField: "username",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
    },
    {
      dataField: "emailId",
      text: "Email",
      headerStyle: (colum, colIndex) => {
        return { width: "120px", textAlign: "center" };
      },
      formatter: emailFormatter,
    },
    {
      dataField: "roleName",
      text: "Role",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "firstName",
      text: "First Name",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "lastName",
      text: "Last Name",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "phoneNumber",
      text: "Mobile No.",
      headerStyle: (colum, colIndex) => {
        return {
          width: "80px",
          textAlign: "center",
        };
      },
    },
    {
      dataField: "address",
      text: "Address",
      headerStyle: (colum, colIndex) => {
        return {
          width: "150px",
          textAlign: "center",
        };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadUser = async () => {
    const query = queryString.getQueryStringFromObj({
      FirstName,
      LastName,
      UserName,
      Email,
      PhoneNumber,
      Address,
      RoleName,
    });

    const response = await getUsersList(query);
    const responseData = response.data;
    setTimeout(() => {
      setTableData(responseData);
      setData(responseData);
      setDataCount(responseData.length);
      setLoading(false);
    }, 10);
  };

  useEffect(() => {
    loadUser();
  }, []);

  const filterHandler = () => {
    const formattedTableData = data.filter((x) => {
      return (
        (UserName.trim() ? x.username?.includes(UserName) : true) &&
        (FirstName.trim() ? x.firstName?.includes(FirstName) : true) &&
        (LastName.trim() ? x.lastName?.includes(LastName) : true) &&
        (PhoneNumber.trim() ? x.phoneNumber?.includes(PhoneNumber) : true) &&
        (Email.trim() ? x.email?.includes(Email) : true)
      );
    });

    setTableData(formattedTableData);
    setDataCount(formattedTableData.length);
  };

  const handleSearch = async () => {
    setLoading(true);

    filterHandler();
  };

  return (
    <>
      {canAdd && (
        <Link
          className="btn btn-primary btn-md float-end"
          to="/admin/users/add"
        >
          <i className="i-Add-User text-white me-2"></i> Add User
        </Link>
      )}
      <Helmet>
        <title>Users List</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Users List" }]}></Breadcrumb>

      <div className=" col-12 d-flex flex-row-reverse mb-2">
        <Button
          variant="primary"
          onClick={() => setIsShowFilter(!isShowFilter)}
        >
          Filter
          <i className="i-Filter-2 ms-2 mt-1"></i>
        </Button>
      </div>

      {isShowFilter ? (
        <div className="card card-body rounded border my-1">
          <div className="row">
            <div className="col-md-2 col-12 mb-1">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <MdVpnKey />
                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="UserName"
                  value={UserName}
                  name="UserName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-md-2 col-12 mb-1">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <FaUserAlt />
                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="FirstName"
                  value={FirstName}
                  name="FirstName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <FaUserAlt />
                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="LastName"
                  value={LastName}
                  name="LastName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>

            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <FaPhoneAlt />
                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="PhoneNumber"
                  value={PhoneNumber}
                  name="PhoneNumber"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <AiFillMail />
                </span>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Email"
                  value={Email}
                  name="Email"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>

            <div className="col-12  col-md-2  d-flex justify-content-around mb-3">
              <button
                className="btn btn-outline-primary mr-3"
                onClick={handleSearch}
              >
                <MdSearch className="mx-2" size={18} />
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={() => refreshFilter()}
              >
                <MdRefresh className="mx-2" size={18} />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}

      <div>
        <HandyScroll>
          <div
            class="spacious-container"
            data-handy-scroll
            style={{ overflow: "auto" }}
          >
            <BootstrapTable
              hover
              //    remote
              keyField="userId"
              data={tableData}
              columns={
                canEdit ? columns : columns.filter((x) => x.text !== "Action")
              }
              pagination={paginationFactory(paginationOptions)}
              //   onTableChange={handleTableChange}
              noDataIndication={() => <NoDataIndication />}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </HandyScroll>
      </div>
    </>
  );
};

export default Users;
